<template>
  <button class="create-gift-button" @click="onClick">
    <span class="create-gift-button__text subhead-bold">
      <span>今すぐ</span>
      <span>贈る</span>
    </span>
  </button>
</template>

<script setup>
const emit = defineEmits(['click-button'])

const onClick = () => {
  emit('click-button')
}
</script>

<style lang="scss" scoped>
.create-gift-button {
  @extend %hover-common;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 108px;
  height: 108px;
  border-radius: 50%;
  background-color: $primary;
  cursor: pointer;

  @media all and (max-width: ($pc-width  - 1)) {
    width: 65px;
    height: 65px;
  }

  &__icon {
    margin-bottom: 10px;
  }

  &__text {
    font-size: 1.4rem;
    line-height: 1;
    color: $white;
    display: flex;

    @media all and (max-width: ($pc-width  - 1)) {
      font-size: 1.2rem;
      flex-direction: column;
      gap: 4px;
    }
  }
}
</style>
